import React, {useMemo} from "react";
import MinMaxSliders from "../../../CommonComponents/MinMaxSliders";
import {useSelectedCard} from "../../../../../contexts/SelectedCardContext";
import {CURRENT_SPORT, MIN_MAX_MINIMUM_SECONDS_DISTANCE} from "../../../../../constants/globalConstants";

interface MatchHighlightParamsProps{
    durationMin: number;
    durationMax: number;
    onDurationChange: (type : 'min' | 'max', value: number) => void
    disabled?: boolean;
}

const MatchHighlightParams: React.FC<MatchHighlightParamsProps> = ({durationMin, durationMax, onDurationChange, disabled = false}) => {
    const {contentType} = useSelectedCard()

    const minDistance: number = useMemo(() => {
        return (MIN_MAX_MINIMUM_SECONDS_DISTANCE as any)[CURRENT_SPORT][contentType] || 0
    }, [contentType]);

    return (
        <MinMaxSliders minValue={durationMin} maxValue={durationMax} onSliderChange={onDurationChange} disabled={disabled} minDistance={minDistance}/>
    )
}

export default MatchHighlightParams;